module.exports = __webpack_public_path__ + "img/stakebodyatten_driving.d12e5bac.svg";